import coreStore from './core-store'

const remoteResource = 'operation/api/v1/operation-link-definitions';

export default coreStore.createCoreStore('operationLinkDefinition', remoteResource);